import React from "react";
import { useHistory } from "react-router-dom";
import { useIntl, FormattedMessage } from "react-intl";

import Breadcrumb from "../Breadcrumb";

import { ReactComponent as BackIcon } from "../../assets/images/back-icon.svg";

import "./style.scss";

const Header = ({ kpiDetails }) => {
  const intl = useIntl();
  const history = useHistory();
  const isAr = intl.locale === "ar";
  const breadcrumbData = [
    {
      ArabicName: <FormattedMessage id="kpi-list.kpi" />,
      EnglishName: <FormattedMessage id="kpi-list.kpi" />,
      path: `/splus/kpi-details/${kpiDetails?.ID}`
    },
    <FormattedMessage id="kpi-change-request" />
  ];

  return (
    <div className="d-flex page-header">
      <BackIcon
        className="cursor"
        style={{ transform: isAr && "rotate(180deg)" }}
        onClick={() => {
          history.push(`/splus/kpi-details/${kpiDetails?.ID}`);
        }}
      />
      <div className="title-wrapper">
        <div className="title">
          <FormattedMessage id="kpi-change-request" />
        </div>

        <Breadcrumb data={breadcrumbData} fontSize="var(--font-large)" />
      </div>
    </div>
  );
};

export default Header;
